import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EmailDeliverability = lazy(() =>
  import("@scenes/AnalyticsDashboard/Deliverability/EmailDeliverability/EmailDeliverability").then((module) => ({
    default: module.EmailDeliverability,
  }))
);

export const dashboardAnalyticsDashboardDeliverabilityEmailNRO: NavigationRoutingObject = {
  Component: EmailDeliverability,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("dashboard-analytics-dashboard-deliverability-email-nro-heading", "Email"),
  pageNameForTracking: () => "Email Deliverability",
  showInSearchResults: false,
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    const userHasViewAppUsagePermission =
      isImpersonating || hasPermission("appGroup", { permission: "viewAppUsage" });
    return featureOn("enable_email_deliverability_dashboard") && userHasViewAppUsagePermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
